import React, { Children, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { StyledMarkdownBlock } from "../../../../components/CodeView";
import { highlight } from "../../../../utils/highlight";
import "./styles.less";

export const DocImg = ({ src, title }) => {
  const { t } = useTranslation();

  return (
    <div className="doc-img">
      {title && <div className="img-title">{title}</div>}
      <img src={src} alt="authing" />
    </div>
  );
};
